module.exports = __webpack_public_path__ + "resources/img/img_ahnlab_vtrusguard_m_en.bdd3b4edd2cc9dd7133efd70d2cba92e.png";